const sortedActionItemsUuids = (state = [], action) => {
  switch (action.type) {
    case 'WORKSPACE_UPDATE_SORTED_ACTION_ITEMS':
      return action.payload.uuids;
    default:
      return state;
  }
};

export default sortedActionItemsUuids;
